module.exports = __webpack_public_path__ + "static/media/logo.9d15d8c0.webp";